let anchorAttrName = "data-goto-anchor";

export function scrollTo(position, callback) {
    let duration = arguments.length <= 2 || arguments[2] === undefined ? 400 : arguments[2];

    $("body, html").animate({scrollTop: position}, duration, function () {
        if (callback) {
            callback();
        }
    });
}

export function scrollToRecursion(target) {
    //var duration = arguments.length <= 1 || arguments[1] === undefined ? 200 : arguments[1];

    let getPosition = function getPosition() {
        let header = $(".header");
        let correctionPosition = 0;

        if (header.length) {
            correctionPosition = parseInt(header.outerHeight());
        }

        return parseInt(target.offset().top) - correctionPosition;
    };
    let position = getPosition();

    scrollTo(position, function () {
        let newPosition = getPosition();
        /*an extra scroll cycle (starting an additional iteration recursion) is made specifically to make allowances for lazy loading blocks*/
        if (position != newPosition) {
            
            scrollToRecursion(target);
        }
    });
}

export function goToAnchor() {
    $(document).ready(function () {
        $("body").on("click", "[" + anchorAttrName + "]", function (e) {
            e.preventDefault();

            var _this = $(this);

            const parent = _this.closest("ul");
            $(parent).find(".active").removeClass("active");

            if(parent.hasClass("scroll-list")) {
                _this.addClass("active");
            } else {
                _this.parent().addClass("active");
            }

            scrollToRecursion($("[data-anchor=" + _this.attr(anchorAttrName) + "]"), 400);
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/goToAnchor.js